export default "__VITE_ASSET__309a4c42__"